import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    zones: [],
    categories: [],
    isLoaded: false,
};

const dataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        setZones: (state, action) => {
            state.zones = action.payload;
        },
        setCategories: (state, action) => {
            state.categories = action.payload;
        },
        setLoaded: (state) => {
            state.isLoaded = true;
        },
    },
});

export const { setZones, setCategories, setLoaded } = dataSlice.actions;
export default dataSlice.reducer;
